import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { chooseDefaultSelectedAddress } from './AddressValidationModal.utils';
import AddressMatchedDisplay from './components/AddressMatchedDisplay';
import AddressSuggestionsDisplay from './components/AddressSuggestionsDisplay';
import NoAddressSuggestionsDisplay from './components/NoAddressSuggestionsDisplay';
import { LocationAddressPropType } from '../../../../services/proptypes';
import { stringifyAddress } from '../../../../utils/address';
var defaultProps = {
  suggestedAddresses: []
};
function AddressValidationModal(_ref) {
  var open = _ref.open,
    manualAddress = _ref.manualAddress,
    suggestedAddresses = _ref.suggestedAddresses,
    _onSelect = _ref.onSelect,
    onCancel = _ref.onCancel;
  var _useState = useState(chooseDefaultSelectedAddress(suggestedAddresses)),
    _useState2 = _slicedToArray(_useState, 2),
    selectedAddress = _useState2[0],
    setSelectedAddress = _useState2[1];
  useEffect(function () {
    return setSelectedAddress(chooseDefaultSelectedAddress(suggestedAddresses));
  }, [suggestedAddresses]);
  if (suggestedAddresses.length === 1) {
    return /*#__PURE__*/React.createElement(AddressMatchedDisplay, {
      open: open,
      matchedAddress: stringifyAddress(selectedAddress),
      manualAddress: stringifyAddress(manualAddress),
      onSelect: function onSelect() {
        return _onSelect(selectedAddress);
      }
    });
  }
  if (suggestedAddresses.length > 1) {
    return /*#__PURE__*/React.createElement(AddressSuggestionsDisplay, {
      open: open,
      suggestedAddresses: suggestedAddresses,
      selectedAddress: selectedAddress,
      manualAddress: stringifyAddress(manualAddress),
      onSelect: setSelectedAddress,
      onConfirm: function onConfirm() {
        return _onSelect(selectedAddress);
      }
    });
  }
  return /*#__PURE__*/React.createElement(NoAddressSuggestionsDisplay, {
    open: open,
    manualAddress: stringifyAddress(manualAddress),
    onCancel: onCancel
  });
}
AddressValidationModal.defaultProps = defaultProps;
export default AddressValidationModal;